import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { isIE11, isEdge } from "../../../lib/client";
import { keyListener } from "../../../lib/events/keyListener";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { Spinner } from "../../Spinner";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles, activeStyles, globalClasses } from "../Button.styles";
import { Corners } from "../Corners";
export var Button = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Button, _React$Component);

  function Button() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      focusedByTab: false
    };
    _this.theme = void 0;
    _this.node = null;

    _this.handleFocus = function (e) {
      if (!_this.props.disabled && !_this.props.disableFocus) {
        // focus event fires before keyDown eventlistener
        // so we should check tabPressed in async way
        requestAnimationFrame(function () {
          if (keyListener.isTabPressed) {
            _this.setState({
              focusedByTab: true
            });
          }
        });
        _this.props.onFocus == null ? void 0 : _this.props.onFocus(e);
      }
    };

    _this.handleBlur = function (e) {
      _this.setState({
        focusedByTab: false
      });

      if (!_this.props.disabled && !_this.props.disableFocus) {
        _this.props.onBlur == null ? void 0 : _this.props.onBlur(e);
      }
    };

    _this._ref = function (node) {
      _this.node = node;
    };

    return _this;
  }

  var _proto = Button.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.autoFocus) {
      keyListener.isTabPressed = true;
      this.focus();
    }
  };

  Button.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    if (props.loading || props.disabled) {
      return {
        focusedByTab: false
      };
    }

    return null;
  }
  /**
  * @public
  */
  ;

  _proto.focus = function focus() {
    var _this$node;

    (_this$node = this.node) == null ? void 0 : _this$node.focus();
  }
  /**
  * @public
  */
  ;

  _proto.blur = function blur() {
    var _this$node2;

    (_this$node2 = this.node) == null ? void 0 : _this$node2.blur();
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return _this2.renderMain();
    });
  };

  _proto.renderMain = function renderMain() {
    var _cx, _cx2, _cx7, _cx8;

    var _this$props = this.props,
        _this$props$corners = _this$props.corners,
        corners = _this$props$corners === void 0 ? 0 : _this$props$corners,
        active = _this$props.active,
        disabled = _this$props.disabled,
        borderless = _this$props.borderless,
        checked = _this$props.checked,
        error = _this$props.error,
        warning = _this$props.warning,
        loading = _this$props.loading,
        arrow = _this$props.arrow,
        narrow = _this$props.narrow,
        icon = _this$props.icon,
        _noPadding = _this$props._noPadding,
        _noRightPadding = _this$props._noRightPadding,
        _this$props$use = _this$props.use,
        use = _this$props$use === void 0 ? Button.defaultProps.use : _this$props$use,
        visuallyFocused = _this$props.visuallyFocused,
        align = _this$props.align,
        disableFocus = _this$props.disableFocus,
        onMouseEnter = _this$props.onMouseEnter,
        onMouseLeave = _this$props.onMouseLeave,
        onMouseOver = _this$props.onMouseOver,
        onKeyDown = _this$props.onKeyDown,
        onClick = _this$props.onClick,
        width = _this$props.width,
        children = _this$props.children;
    var sizeClass = this.getSizeClassName();
    var isFocused = this.state.focusedByTab || visuallyFocused;
    var isLink = use === 'link';
    var rootProps = {
      // By default the type attribute is 'submit'. IE8 will fire a click event
      // on this button if somewhere on the page user presses Enter while some
      // input is focused. So we set type to 'button' by default.
      type: this.props.type,
      className: cx((_cx = {}, _cx[styles.root(this.theme)] = true, _cx[styles[use](this.theme)] = true, _cx[activeStyles[use](this.theme)] = active, _cx[sizeClass] = true, _cx[styles.focus(this.theme)] = isFocused && !checked, _cx[styles.checked(this.theme)] = checked, _cx[styles.disabled(this.theme)] = disabled || loading, _cx[styles.checkedDisabled(this.theme)] = checked && disabled, _cx[styles.borderless()] = borderless && !disabled && !loading && !checked && !isFocused && !active, _cx[styles.narrow()] = narrow, _cx[styles.noPadding()] = _noPadding, _cx[styles.noRightPadding()] = _noRightPadding, _cx)),
      style: {
        borderTopLeftRadius: corners & Corners.TOP_LEFT ? 0 : undefined,
        borderTopRightRadius: corners & Corners.TOP_RIGHT ? 0 : undefined,
        borderBottomRightRadius: corners & Corners.BOTTOM_RIGHT ? 0 : undefined,
        borderBottomLeftRadius: corners & Corners.BOTTOM_LEFT ? 0 : undefined,
        textAlign: align
      },
      disabled: disabled || loading,
      onClick: onClick,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onKeyDown: onKeyDown,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseOver: onMouseOver,
      tabIndex: disableFocus ? -1 : 0,
      title: this.props.title
    };
    var wrapProps = {
      className: cx((_cx2 = {}, _cx2[styles.wrap()] = true, _cx2[styles.wrapArrow()] = arrow === true, _cx2[styles.wrapArrowLeft()] = arrow === 'left', _cx2)),
      style: {
        width: width
      }
    };
    var outlineNode = null;

    if (!isFocused || isLink) {
      var _cx3;

      outlineNode = /*#__PURE__*/React.createElement("div", {
        className: cx(styles.outline(), (_cx3 = {}, _cx3[styles.outlineWarning(this.theme)] = warning, _cx3[styles.outlineError(this.theme)] = error, _cx3[styles.outlineLink()] = isLink, _cx3[styles.outlineLinkWarning(this.theme)] = isLink && warning, _cx3[styles.outlineLinkError(this.theme)] = isLink && error, _cx3))
      });
    }

    var loadingNode = null;

    if (loading && !icon) {
      loadingNode = /*#__PURE__*/React.createElement("div", {
        className: styles.loading()
      }, this.getLoadingSpinner());
    }

    var iconNode = null;

    if (icon) {
      var _cx4;

      iconNode = /*#__PURE__*/React.createElement("span", {
        className: cx(styles.icon(), this.getSizeIconClassName(), (_cx4 = {}, _cx4[styles.iconNoRightPadding()] = !children, _cx4[styles.iconLink(this.theme)] = isLink, _cx4))
      }, loading ? this.getLoadingSpinner() : icon);
    }

    var arrowNode = null;

    if (arrow) {
      var _cx5;

      arrowNode = /*#__PURE__*/React.createElement("div", {
        className: cx((_cx5 = {}, _cx5[styles.arrow()] = true, _cx5[styles.arrowWarning(this.theme)] = !checked && warning, _cx5[styles.arrowError(this.theme)] = !checked && error, _cx5[styles.arrowFocus(this.theme)] = !checked && isFocused, _cx5[styles.arrowLeft()] = arrow === 'left', _cx5))
      }, /*#__PURE__*/React.createElement("div", {
        className: cx(globalClasses.arrowHelper, globalClasses.arrowHelperTop)
      }), /*#__PURE__*/React.createElement("div", {
        className: cx(globalClasses.arrowHelper, globalClasses.arrowHelperBottom)
      }));
    } // Force disable all props and features, that cannot be use with Link


    if (isLink) {
      var _cx6;

      rootProps.className = cx((_cx6 = {}, _cx6[styles.root(this.theme)] = true, _cx6[sizeClass] = true, _cx6[styles.link(this.theme)] = true, _cx6[styles.linkFocus(this.theme)] = isFocused, _cx6[styles.linkDisabled(this.theme)] = disabled || loading, _cx6));
      Object.assign(wrapProps, {
        className: cx(styles.wrap(), styles.wrapLink()),
        style: {
          width: wrapProps.style.width
        }
      });
      rootProps.style.textAlign = undefined;
      arrowNode = null;
    }

    return /*#__PURE__*/React.createElement(CommonWrapper, this.props, /*#__PURE__*/React.createElement("span", wrapProps, /*#__PURE__*/React.createElement("button", _extends({
      ref: this._ref
    }, rootProps), outlineNode, loadingNode, arrowNode, /*#__PURE__*/React.createElement("div", {
      className: cx(styles.caption(), globalClasses.caption, (_cx7 = {}, _cx7[styles.captionTranslated()] = active || checked, _cx7[styles.captionLink()] = isLink, _cx7[styles.captionDisabled()] = !checked && disabled, _cx7))
    }, iconNode, /*#__PURE__*/React.createElement("span", {
      className: cx((_cx8 = {}, _cx8[styles.visibilityHidden()] = !!loadingNode, _cx8))
    }, children)))));
  };

  _proto.getLoadingSpinner = function getLoadingSpinner() {
    return /*#__PURE__*/React.createElement(Spinner, {
      caption: null,
      dimmed: true,
      type: "mini"
    });
  };

  _proto.getSizeClassName = function getSizeClassName() {
    var _cx9, _cx10, _cx11;

    switch (this.props.size) {
      case 'large':
        return cx(styles.sizeLarge(this.theme), (_cx9 = {}, _cx9[styles.sizeLargeIE11(this.theme)] = isIE11 || isEdge, _cx9));

      case 'medium':
        return cx(styles.sizeMedium(this.theme), (_cx10 = {}, _cx10[styles.sizeMediumIE11(this.theme)] = isIE11 || isEdge, _cx10));

      case 'small':
      default:
        return cx(styles.sizeSmall(this.theme), (_cx11 = {}, _cx11[styles.sizeSmallIE11(this.theme)] = isIE11 || isEdge, _cx11));
    }
  };

  _proto.getSizeIconClassName = function getSizeIconClassName() {
    switch (this.props.size) {
      case 'large':
        return styles.iconLarge(this.theme);

      case 'medium':
        return styles.iconMedium(this.theme);

      case 'small':
      default:
        return styles.iconSmall(this.theme);
    }
  };

  return Button;
}(React.Component);
Button.__KONTUR_REACT_UI__ = 'Button';
Button.__BUTTON__ = true;
Button.TOP_LEFT = Corners.TOP_LEFT;
Button.TOP_RIGHT = Corners.TOP_RIGHT;
Button.BOTTOM_RIGHT = Corners.BOTTOM_RIGHT;
Button.BOTTOM_LEFT = Corners.BOTTOM_LEFT;
Button.defaultProps = {
  use: 'default',
  size: 'small',
  type: 'button'
};
export var isButton = function isButton(child) {
  return /*#__PURE__*/React.isValidElement(child) ? Object.prototype.hasOwnProperty.call(child.type, '__BUTTON__') : false;
};